import { setPersistence, browserSessionPersistence, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "services/firebase";

export const getUserFreeTrialStatus = async (uid: string) => {
    const userRef = doc(db, "users", uid); 
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
        const data = userDoc.data();
        if (data && data.hasOwnProperty('freeTrial')) {
            return data.freeTrial;
        } else {
            // If freeTrial doesn't exist, set it to true
            await setDoc(userRef, { freeTrial: true }, { merge: true });
            return true;
        }
    } else {
        console.error("No such user!");
        return false;
    }
}
  

export const signUp = async (email: string, password: string) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    setDoc(doc(db, "users", userCredential.user.uid), {
        //TODO add more user info'
        email: userCredential.user.email,
        freeTrial: true
    })
    return userCredential.user;
};

export const signIn = async (email: string, password: string) => {
    await setPersistence(auth, browserSessionPersistence);
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
};

export const signOut = async () => {
    await auth.signOut();
}